import { render, staticRenderFns } from "./assignments-evaluations.vue?vue&type=template&id=3f0a1ad2&"
import script from "./assignments-evaluations.vue?vue&type=script&lang=js&"
export * from "./assignments-evaluations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports